/**
 * Deploy environment, injected at build time by webpack's DefinePlugin.
 *
 * Without this, prod and non-prod events land in the same Sentry environment and
 * can only be told apart by digging into an event payload - so a non-prod smoke
 * test looks identical to a real client failure.
 *
 * The identifier is guarded with `typeof` so the module still resolves when no
 * DefinePlugin is present (ts-jest, or a plain `tsc`), defaulting to the safe
 * assumption that this is production.
 */
declare const __FOUNTAIN_ENVIRONMENT__: string;

export const ENVIRONMENT: string =
    typeof __FOUNTAIN_ENVIRONMENT__ !== 'undefined' ? __FOUNTAIN_ENVIRONMENT__ : 'production';
